import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InventoryGoodsReceiptAdjustmentIssueDateEarlierThanAdjustedError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.inventory.goods-receipt-adjustment.validation.issue-date.earlier-than-adjusted');
    }
}
